module.exports = __webpack_public_path__ + "41b3121f76c6a208be534fcde6fddd8e.pdf";